var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    transform: "translate(321 1888)",
    fill: "#fff",
    stroke: "#4a13b2",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 54.5,
    height: 54.5,
    rx: 27.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_presention-chart",
    "data-name": "vuesax/linear/presention-chart",
    transform: "translate(-28.779 1650.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "presention-chart",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.341,17.224h14a2.974,2.974,0,0,0,3.33-3.33V0H0V13.894A2.988,2.988,0,0,0,3.341,17.224Z",
    transform: "translate(3.433 2.297)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H22.965",
    transform: "translate(2.297 2.297)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,5.741l4.593-2.3V0",
    transform: "translate(9.186 19.521)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M4.593,2.3,0,0",
    transform: "translate(13.779 22.965)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,3.445,3.617.425a.554.554,0,0,1,.861.149l1.378,2.3a.561.561,0,0,0,.861.149L10.334,0",
    transform: "translate(8.612 9.186)",
    fill: "none",
    stroke: "#4a13b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H27.559V27.559H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPScreen);
export default __webpack_public_path__ + "static/media/p-screen.96d5d760d76bb5ca65c0a5764782d853.svg";
export { ForwardRef as ReactComponent };